<template>
  <div class="login-page">
    <form id="form" action class="login-box" v-on:submit="login">
      <h2 class="login-box__title">Welcome, Please Login</h2>

      <div>
        <div class="login-box__input-group">
          <label for class="login-box__label">User Name</label>
          <input
            type="text"
            v-model="username"
            class="login-box__input"
            name="username"
            placeholder="..."
          />
        </div>

        <div class="login-box__input-group">
          <label for class="login-box__label">Password</label>
          <input
            type="password"
            v-model="password"
            class="login-box__input"
            name="password"
            placeholder="..."
          />
        </div>
      </div>

      <input type="submit" value="login" class="btn btn--blue3 login-box__submit" />
    </form>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
export default Vue.extend({
  name: "home",
  data() {
    return {
      username: "",
      password: ""
    };
  },

  methods: {
    login: function(e) {
      e.preventDefault();
      let data = {
        username: this.username,
        password: this.password
      };
      this.$store.dispatch('authRequest', data).then(() => {

        this.$router.push("/summary");

      });
    }
  }
});
</script>

<style lang="scss" scoped>
.login-page {
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
}

.login-box {
  border: 2px solid $border-color;
  margin: 100px auto 0;
  border-radius: 20px;

  background: #e0e0e0;
  padding: 30px 0 35px;
  width: 370px;

  &__title {
    margin-bottom: 40px;
    text-align: center;
    font-weight: bold;
    line-height: 22px;
    font-size: 18px;
  }

  &__input-group {
    display: flex;
    flex-direction: column;
    margin: 0 auto 20px;
    position: relative;
    width: 80%;
  }

  &__label {
    background-color: $color1;
    line-height: 10px;
    font-weight: 700;
    font-size: 10px;

    text-align: center;
    text-transform: uppercase;
    border-radius: 3px;
    padding: 5px 0;
    width: 75px;

    transform: translateY(-50%);
    position: absolute;
    left: 15px;
    top: 0;

    background-color: $table-light-bg;
  }

  &__input {
    background-color: $table-light-bg;
    border: 2px solid $border-color;
    padding: 15px 10px 10px;
    border-radius: 5px;
  }

  &__submit {
    text-transform: uppercase;
    font-weight: bold;

    display: block;
    font-size: 12px;
    margin: 30px auto 0;
    border-radius: 5px;
    padding: 8px 0;
    width: 120px;
  }
}
</style>
